module.exports = __webpack_public_path__ + "static/media/anexo.5a7f939b.jpg";